"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useEllipsis;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
// Pass `textValue` if the element text is dynamic and you want to recalculate `isEllipsis`

function useEllipsis() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    textValue = _ref.textValue;
  var elemRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isEllipsisActive = _useState2[0],
    setIsEllipsisActive = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!elemRef.current) {
      return;
    }
    setIsEllipsisActive(elemRef.current.scrollWidth > elemRef.current.offsetWidth);
  }, [textValue]);
  return [elemRef, isEllipsisActive];
}
//# sourceMappingURL=useEllipsis.js.map